<template><div class="BigScheme">
  <div v-if="hasSvg" class="legend">
    <div class="legend-ul">
      <div v-if="bookMode" class="legend-li">
        <svg class="scheme legend-li--scheme" width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
          <g class="SelectorG any">
            <rect class="cabin" x="0" y="0" width="30" height="20"></rect>
            <text class="cabin_num" text-anchor="middle" transform="translate(15,15)" text-rendering="geometricPrecision">11</text>
            <text class="cabin_vacancies" text-anchor="middle" transform="translate(15,30)">2+1</text>

          </g>
        </svg>
        <div class="legend-li--desc">каюта занята</div>
      </div>
      <div v-if="bookMode" class="legend-li">
        <svg class="scheme legend-li--scheme" width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
          <g class="SelectorG free">
            <rect class="cabin" x="0" y="0" width="30" height="20"></rect>
            <text class="cabin_num" text-anchor="middle" transform="translate(15,15)" text-rendering="geometricPrecision">22</text>
            <text class="cabin_vacancies" text-anchor="middle" transform="translate(15,30)">2+1</text>

          </g>
        </svg>
        <div class="legend-li--desc">каюту можно бронировать</div>
      </div>
      <div v-if="bookMode" class="legend-li">
        <svg class="scheme legend-li--scheme" width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
          <g class="SelectorG free prebook">
            <rect class="cabin" x="0" y="0" width="30" height="20"></rect>
            <text class="cabin_num" text-anchor="middle" transform="translate(15,15)" text-rendering="geometricPrecision">33</text>
            <text class="cabin_vacancies" text-anchor="middle" transform="translate(15,30)">2ч</text>

          </g>
        </svg>
        <div class="legend-li--desc">размещено 2 гостя</div>
      </div>

      <div v-if="!bookMode" class="legend-li">
        <svg class="scheme legend-li--scheme" width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.o+rg/2000/svg">
          <g class="">
            <rect class="cabin" x="0" y="0" width="30" height="20" style="fill:rgb(168, 182, 255);"></rect>
            <text class="cabin_num" text-anchor="middle" transform="translate(15,15)" text-rendering="geometricPrecision">44</text>
            <text class="cabin_vacancies" text-anchor="middle" transform="translate(15,30)">2+1</text>

          </g>
        </svg>
        <div class="legend-li--desc">одна цена - один цвет</div>
      </div>


      <div class="legend-li">
        <span class="legend-li--scheme cabivac">2+1</span>
        <span class="legend-li--desc">основных мест + дополнительных</span>
      </div>
    </div>
  </div>
  <div v-if="hasScheme" class="win">
    <div class="win-core" :class="{svg:hasSvg}">
      <div class="win-core--scheme" ref="rootScheme" :class="{svg:hasSvg}" :style="schemeStyle"><img v-if="!hasSvg" :src="scheme_jpg"><!-- svg class=scheme --></div>
    </div>
    <div class="win-tools">
      <button class="win-tools--plus" @click="zoomPlus"><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 5.992c0-.537.448-.992 1-.992.556 0 1 .444 1 .992V11h5.008c.537 0 .992.448.992 1 0 .556-.444 1-.992 1H13v5.008c0 .537-.448.992-1 .992-.556 0-1-.444-1-.992V13H5.992C5.455 13 5 12.552 5 12c0-.556.444-1 .992-1H11V5.992z" fill="currentColor"></path></svg></button>
      <button class="win-tools--minus" @click="zoomMinus"><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 12a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1z" fill="currentColor"></path></svg></button>
    </div>
    <div class="win-load" v-if="!schemeDim.loaded"><Loader class="win-load--loader" /></div>
    <div class="win-load" v-if="schemeDim.error">Не удалось загрузить схему</div>
  </div>

</div></template>

<style lang="scss" src="./BigScheme.scss"></style>

<script setup>
import {computed, ref, unref, onMounted, onUnmounted} from 'vue'
import {fetch_svg} from '@/actions.js'
import Panzoom from '@panzoom/panzoom'
import Vue from 'vue'
import { createApp } from 'vue'
import Loader from '@/comp/Loader/Loader.vue'

import RoomSelectorG from '@/comp/FaseList/RoomSelectorG.vue'


const scss_copy={
  bigHeight: 600,
  bigHeightScale: .5,
  bigHeightBreak: 600,
}


const WINH = window.screen.width > scss_copy.bigHeightBreak ?  scss_copy.bigHeight : scss_copy.bigHeight * scss_copy.bigHeightScale;

const schemeDim = ref({width: 0, height: 0, loaded: false, error:false})

const schemeStyle = computed(() => {
  const dim = unref(schemeDim)
  let {width, height} = dim
  let ret = width ? {
    width: `${width}px`,
    height: `${height}px`,
  } : {
    width: 'auto',
    height: 'auto',
  }
  return ret
})


const rootScheme = ref(null) // задана в темлейте, приемник svg


const props = defineProps({
  CabinMap: Object,
  scheme: Object,
  show: String, // free - только свободные с возможностью забронить, иначе все без такой возможности
})

const { 
    jpg: scheme_jpg, svg: scheme_svg,
} = props.scheme

const hasSvg = scheme_svg ? true : false
const hasScheme = scheme_jpg || scheme_svg  ? true : false

const bookMode = Boolean( props.CabinMap )

const pan = ref(null) // ссылка на panzoom

const collectGAttrs =  g => {
  let cab = g.querySelector('rect.cabin')
  let vac = g.querySelector('text.cabin_vacancies')
  let num = g.querySelector('text.cabin_num')
  let cabAttrs
  if (cab) {
    cabAttrs = getAttrs(cab)
  }
  let vacAttrs
  if (vac) {
    vacAttrs = getAttrs(vac)
  }
  let numAttrs
  if (num) {
    numAttrs = getAttrs(num)
  }
  const ok = cab && vac && num ? true : false
  const ret = {
    ok, cab, vac, num, cabAttrs, vacAttrs, numAttrs
  }
  return ret
}
const getAttrs = node => {
  let attrs = {}
  for (const attr of node.attributes) {
    const {name,value} = attr
    if (["class", "style"].includes( name )) {
      continue;
    }
    attrs[name] = value
  }
  attrs.styleFill = node.style.fill 
  attrs.text = node.textContent || ''
//console.log('getAttrs', node)
  return attrs
}


const svgel_from_text = (text) => {
  const root = document.createElement('div')
  root.innerHTML = text
  let svg = root.querySelector('svg')
  svg.removeAttribute('id')
  svg.setAttribute('class', 'scheme')
  let width = svg.getAttribute('width')
  let height = svg.getAttribute('height')

  if (props.CabinMap) {
    svg.querySelectorAll('g[data-cabin-id]').forEach( (g,gindex) => {
//      if (gindex>0) return; // DEBUG
//console.log('svg.querySelectorAll', g)

      let cabinId = g.getAttribute('data-cabin-id')

      const collect = collectGAttrs(g)

      let skipMount = ''
      if (!collect.ok) {
        skipMount = `каюта ${cabinId} странная разметка в svg`
      }

      const cabinCabinSet = props.CabinMap[ cabinId ]
      if (!cabinCabinSet) {
        skipMount = `каюта ${cabinId} есть на схеме, но нет в данных`
      }
      if (skipMount) {
        g.setAttribute('class', 'SelectorG')
        if (collect.cab) {
          collect.cab.setAttribute('style', '')
        }
        console.error(skipMount)
        return
      }

      collect.vac.remove()
      collect.num.remove()

      const RoomProps={
        Cabin: cabinCabinSet.Cabin,
        CabinSet: cabinCabinSet.CabinSet,
        cabAttrs: collect.cabAttrs,
        vacAttrs: collect.vacAttrs,
        numAttrs: collect.numAttrs,
      }

      const mountPoint = document.createElementNS('http://www.w3.org/2000/svg', 'g')
      collect.cab.parentNode.replaceChild(mountPoint, collect.cab)

      let vco=new Vue({
        render: h => h(RoomSelectorG, {props: RoomProps}),
        el: mountPoint,
      })
//      vco.$mount(mountPoint)
//console.log('RoomProps Cabin', RoomProps.Cabin)


    } )
  }


  return {svg, width, height}
}



onMounted( () => {
  const rootSchemeEl = unref( rootScheme )
  let doit = Promise.resolve(true)
  if ( hasSvg ) {
    doit = fetch_svg( scheme_svg ).then( svghtml => {
        let {svg, width, height} = svgel_from_text(svghtml)
        schemeDim.value = {
          width, 
          height,
          loaded: true,
        }
        rootSchemeEl.appendChild( svg )
        return true
      })
  } else if (hasScheme) {
    doit = fetch_img_attrs( scheme_jpg ).then( ({ width, height })=>{
        schemeDim.value = {
          width,
            height,
            loaded: true,
        }
      return true
    } )
  }
  if ( hasScheme ) {
    doit = doit.then(()=>{
      let {height} = unref( schemeDim.value )
      height = parseFloat( height )
      let needScale = height > WINH * 3
      let startScale = needScale ? WINH * 3 / height : 1
      let panOpts = { 
        contain: "outside",
        startX: 0,
        startY: 0,
        excludeClass: 'cabin--free',
      }
      pan.value = Panzoom( rootSchemeEl, panOpts )
      if (needScale) {// делаю через timeout иначе Panzoom не успевает прожевать большую картинку
        // на Astoria такое
        setTimeout( ()=> {
          pan.value.zoom(startScale)
        }, 10 )
      }

      return true
    }, ()=> {
      schemeDim.value.loaded = true
      schemeDim.value.error = true
      return true
    })
  }
} )

const zoomPlus = () => {
  pan.value.zoomIn()
}
const zoomMinus = () => {
  pan.value.zoomOut()
}


const fetch_img_attrs = url => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = function() {
      let {width, height} = img
        resolve( { width, height });
    };
    img.onerror = function(e) {
      console.error('fetch_img_attrs', e)
        reject('failed');
    };
    img.src = url;
  });
}

//window.Panzoom = Panzoom


</script>
